module.exports = __webpack_public_path__ + "img/visual-08.fe2c7d4f.jpg";